<template>
  <div class="card">
    <div class="card-body">
      <div
        v-if="managedStaffList.length"
        class="table-responsive"
      >
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Staff Name</th>
              <th>Staff Email</th>
              <th>Annual Vacation Days</th>
              <th>Remain Annual Vacation Days</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="staff in managedStaffList"
              :key="staff.id"
            >
              <td><a :href="`/admin/vacation/staff-tracker/${staff.id}`">{{ staff.user.full_name }}</a></td>
              <td>{{ staff.user.email }}</td>
              <td>{{ staff.annual_leave_days }}</td>
              <td>{{ staff.remain_annual_vacation_days }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p>No staffs found</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

 export default {
     name: 'ManagerVacationTracker',
     props: {
         managerId: {
             type: Number,
             required: true,
         },
     },
     computed:{
         ...mapGetters({
             managedStaffList: 'vacation/managedStaffList'
         })
     },
     mounted() {
         this.fetchStaffs()
     },
     methods : {
         fetchStaffs() {
             this.getManagedStaffList({'manager_id' : this.managerId});
         },
         ...mapActions({
             getManagedStaffList: 'vacation/getManagedStaffList'
         })
     }
 }
</script>
